<template>
	<div class="logo" :style="{ margin }">
		<div class="logoWrap">
			<img v-if="isLogo && isErrorFile" @error="onError" :src="linkMod(logo.url)" alt="logo">
			<svg-sprite v-else style="color: #8f90a680" width="48" height="56" icon-id="user"></svg-sprite>
		</div>
		<div class="logoInfo" :class="{'invalid': isValid}">
			<p class="logoInfo-title">{{ title }}</p>
			<div class="existFile" v-if="isLogo">
				<span :title="logo.name" class="existFile-name">{{ logo.name }}</span>
				<button @click="onFileRemove">
					<svg-sprite class="deleteItem" width="20" height="20" icon-id="deleteItem"></svg-sprite>
				</button>
			</div>
			<p v-else class="logoInfo-desc">File must be gif, png, jpeg or jpg (max 2MB).</p>
<!--			<div class="upload">-->
<!--				<svg-sprite class="iconUploadFile" width="20" height="20" :icon-id="isLogo ? 'reChange' : 'upload'"></svg-sprite>-->
<!--				<label>-->
<!--					{{ isLogo ? 'Change file' : 'Upload file' }}-->
<!--					<input style="display: none;" accept=".png, .jpg, .jpeg, .gif" type="file" @change="onFile">-->
<!--				</label>-->
<!--			</div>-->
			<div class="upload">
				<svg-sprite class="iconUploadFile" width="20" height="20" :icon-id="isLogo ? 'reChange' : 'upload'"></svg-sprite>
				<label @click="toggleShow">
					{{ isLogo ? 'Change file' : 'Upload file' }}
				</label>
			</div>
		</div>

		<my-upload
				field="img"
				@crop-success="cropSuccess"
				@crop-upload-success="cropUploadSuccess"
				@crop-upload-fail="cropUploadFail"
				@src-file-set="srcFileSet"
				v-model="show"
				langType="en"
				:width="480"
				:height="480"
				:params="params"
				:headers="headers"
				img-format="png"
				noCircle
		></my-upload>
		<!--		url="/uploadUserPhoto"-->

	</div>
</template>

<script>
import { getAppUrl } from "@/services";
// constants
import { ACCESS_FILES } from "@/components/Maintenance/Customer/CustomerForm/constants";
import myUpload from "vue-image-crop-upload/upload-2.vue";

export default {
	name: "LogoBlock",
	components: { myUpload },
	props: {
		margin: {
			type: String,
			default: () => '0'
		},
		logo: {
			type: Object,
			default: () => {}
		},
		title: String
	},
	computed: {
		isLogo() {
			return !!this.logo?.url;
		}
	},
	data: () => ({
		isValid: false,
		isErrorFile: true,

		logoMod: {},

		show: false,
		params: {
			token: '123456798',
			name: 'avatar'
		},
		headers: {
			smail: '*_~'
		},
		imgDataUrl: '', // the datebase64 url of created image
	}),
	methods: {
		onFile(evt) {
			const { files } = evt?.target || evt?.dataTransfer;

			if (files) {
				this.isErrorFile = true;
				const { size, name } = files[0];
				const format = name.split('.').pop();
				const isFormat = ACCESS_FILES.includes(format);

				if (size <= 2097152 && isFormat) {
					const reader = new FileReader();
					this.isValid = false;
					reader.readAsDataURL(files[0]);

					reader.onload = () => {
						const logo = {
							name,
							value: reader.result,
							url: reader.result
						};

						this.$emit('updateFile', logo);
					};
				} else {
					this.isValid = true;
					this.$emit('updateFile', null);
				}
			}
		},
		onFileRemove() {
			this.$emit('updateFile', null);
		},
		linkMod(url) {
			return url.includes('data:') ? url : getAppUrl + url;
		},
		onError() {
			this.isErrorFile = false;
		},
		srcFileSet(args) {

			this.logoMod.name = args;

			// logo:Object
			// name:"kivi-avatar.png"
			// url:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7N13mBX1vT/w93dmTt3GVtild6WJIkVAY4uxJcayK6Dyi43kaowBLDG5iZubXGOMisabGEvUqKDsookajbFEY4LYaSIdFoRdYNm+p8/M9/cHkEu4tGXPnM935nxez5Mnz+OT7Lw9Z858P/OtAGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMZS9BHYAx5qyayko9NdiXDwDBuBaEsEMAkBJaniZsAwA0W8YFRAwALDPVkcrxmT6Zsqt+WdtGl5wx5iQuABhziZpbK3tpll4upV5qa3axBpTYUhQLoFhAFEvIYgClAIoB5AEoAKCl6fIJABFINEGgCVI0SSGbNIkmKWSTlFoThN2oaXqTtGRT0sSWKx+a356mazPGHMAFAGOKmP+DGYWBhKywIMqFhkFCYpAEBmHPf4ZhT6PuJi0AGiBQDxubpMAmDXv+O6AH1110zxMd1AEZy2ZcADCWYTU3VZYKn38MgNGAPVpCjMGeBj6fOFqm7QTwhQBWQsiV0hYr4rq+aua9z0SogzGWDbgAYMwhj8ya5SvObR8loY0GMFoCYwAxBpC9qLMpzAawCcDyPYUBVkpbW1E579mNApDU4RjzEi4AGEuTZ2+6It9nyAkQmCoEpkBiCoAQdS6PaIfAR1JiMST+KZBaXDWvNkYdijE34wKAsWP03G3TKgxTmwJgqgSmADgR6Zt0xw7PxJ5egsUAPpWW8W7Vg09vpQ7FmJtwAcDYUaq5tbIXLN+5AM4FcAaAMuJI7N+tk0K8Bdt+PaEbf+O5BIwdHhcAjB1CTWWljn6+sVLibAF8HcBk8G/GLUwAH0rgFSHwVuV9Cz7jOQSM/Tt+mDG2n5rZM3sD5rmAPBdCnA2gB3UmlhZbJMTrEPbrIma+VfXb2k7qQIxR4wKAZb0Fc6eXGBCXQGIm+C0/GyQAvCmAWr8R/CPvR8CyFT/oWFZ68caZxVbAvEACldgzpm9QZ2Ik4gDeEkCtjKde5J4Blk24AGBZo2Z2ZZEQvgu50WeHEAPwtgBqY5r+Ak8iZF7HBQDztHeqTzd2dZRfKGztOgh5LgCdOhNzhXYBudAS2mPT7pv/MXUYxpzABQDzpBduu6KPacorBHADgH7UeZibidUS8g++hPH4Jb95uok6DWPpwgUA84ya6kq/aPddJIGZAM4Dv+2z9EoAeFlKPFo1b8HbvKyQuR0XAMz1np9z+TAhtFlCipnYcxwuYw4TqwH7cUjzqap5tc3UaRg7FlwAMNdaOHfGaULKuYC4ELwFL6MRAfCkrVsPTPvVwo3UYRjrCi4AmKtUV1drx7etvUBo4g5InEKdh7G9bACvSVvcffkD8xdTh2HsaHABwFyh5obKXIR8MyAxF8Aw6jyMHcanAvh1SX79gjOq3zWpwzB2KFwAMKXtPXHvexL4NnhbXuYuG4SU8yTMJ/noYqYiLgCYkmpuqiwVPt9cCXwPQIg6D2Pd0CiB+4RM/ZoLAaYSLgCYUl68cWZxKmDeJIA5APKo8zCWNhLboOHe3GTL785/6C8J6jiMcQHAlPDSbdfkxc34DQK4A0ABdR7GHLQVAv9dmlf/BM8RYJS4AGCkam6ozJVB340CuB1AIXUexjKoDgK/wNbU76tqay3qMCz7cAHASNRUV/rRbnwXQvwQEsXUeRgj9AU0+7aqe59/lToIyy5cALCMWzh7xtlC4AEAI6mzMKaQtyHF7Kp581dSB2HZgQsAljE1N185HJq8D0JeQJ2FMUWZkHgCZuo/qx6qbaQOw7yNCwDmuPk/mFHoT+J2CcwG4KfOw5gLtEDgp6V59b/hiYLMKVwAMMe8U3260dhRcQ0kfg4+pIexrhNYKyXmXH7/gteoozDv4QKAOaJ2zrTJEuIRQIyizsKY+8k/Qvpuqpr39HbqJMw7uABgafXKrFnheG7nTyRwCwCdOg9jHtIGgTu/yBv2UHV1tU0dhrkfFwAsbRbOmXG+AB4G0I86C2Metti2reunPbBwNXUQ5m5cALBue/GWq8os235AQk6nzsIA6IAWtIGghPDbEMbef+6XgJAQAhB+ueefGRKwBWADUgIyufeRYAEwNQB7/1lKwI4JyIS25+BbRi0OyJ+3dObd8+1HH01Rh2HuxAUA65baOTNmSoH7eTMf54mghJZvQeTZ0PItaHk2RNCGCEmIoA0ttLfR90lHc8i4gIxrkHsLAjumATEBq0OHbNcg23VY7Rpg8uMlA1ZC4rqqeQs+og7C3Id/oeyYPDdnWl8d2uMAzqHO4iXCL6EVm9BLLGg9rD0Nfv6eBv9fb+0uIaMCdrsBe19R0KLDatJhNxnci5BelpD4dWeB/4dXVz8Vpw7D3IMLANZlC+dMv1RAPAqgiDqLa2mAlmdBK7Sgl5nQiy1ohSa0Isv7v0obsDt0WM067F3Gnv9uNmC36IC7ahzFiNWw5YyqBxYso07C3MHrjxqWRi/ddk1eIhW/FwKzqLO4jk/C6GVCL09Br0jBKDf3jL+zf5FJAWunAaveB6vBB7PB4GGErktI4M7V+cN+xSsF2JHwr4sdlefnXDFJg5wPYBB1FjfQCiwYFSlo5SaM8hS0wix4s083C7B2GTB3+P5VFMgYf4hH6a+6rV196QPPNlAHYeriXxM7rJrKSl329d0igJ8B8FHnUdbeN3xjYBLGwAS0fH75coLdpCNV54f1pR/mdh/PJTi83ULiusp5C16iDsLUxAUAO6QX5s7ob0n5DCBOpc6iIq3AgjEguafRr0jxtkcZJlMC5jYfrM1+mFv8sDs16khqkngmruv/MfPeZyLUUZhauABgB7V3ot8TAPKpsyhDAHp5Cr6hSfgGJSFyLepEbD/WbgPmBj9SGwJ7JhSy/YjVtm1eypsHsf1xAcD+zd4u/x8L4Cfg+wMAoBVZ8A1JwHd8Alo+N/puYDfpSG0IILUuALuVi4G9OgVwTeX9C2qpgzA18AOe/cuCudNLDCmeB3AWdRZqek8TviEJGEOT0PK40Xcza5eB1PoAUusDkB1ZP0wgJeSvxJfmD6tqa/nGznJcADAAwPPfv/IkTbNfADCAOgsVEbDhG5KEb0wcegkfwe45ErB2+JBaHUBybSDblxi+Z1qyasaDz+2kDsLoZPUvgO1RO2fGTAn8DkCIOgsFvcyEb1Qc/mEJwOFtdJkaZEIgtSGA5PLgnp0Js5HENluIymn3z/+AOgqjwQVAFnvtpvMCEV/hPRL4HnWWTNPCNoyhCfhHxqEVc09oNrN2GUh9HkRqXQAylXWPxAQEbq+6b8GD1EFY5mXd3c72WHDz9J6Gpr0EISdSZ8kkrdhE4MQ4fMPjQNYPB7P9ybiG5IoAkitCkLHsujmEwO9K8upvOqP6XR77yiJcAGShmtlXDgHs1yAwlDpLphgVKfhOisE3IMl3PTs8G0itCyDxWRh2U1atIHgTvlRl1S9r26iDsMzgR2GWWfj9K6YITf4JQAl1FqcJTUIflERgXAx6Gb/YsC6SgLnNh+SyEMw6P3WaTFkJy7iw6sGnt1IHYc7jAiCL1MydcRUkHgfg7aeZIREYFYf/xDhv1sPSwtplIPFxGOZmv/dPLJTYZgvtwmn3P7ucOgpzFhcAWaJm7oybITEPXv7ONcB/fByBCTFu+Jkj7CYd8Y/CMDcEqKM4rROaPa3q3udfpQ7CnOPdxoABAN6pPt1obKv4jZeP8BWahDE0icDEKLQCbviZ86wdPiQ+9vzQgCWk/F7lvOd+Sx2EOYMLAA+rub2yAEnfixA4kzqLIzTAPzwO//gYN/yMhLXdh/iSMKwGDx+UKcXdlfPm/1B4f/Aj63AB4FEv3jiz2AyYrwM4mTqLE4z+SQSmRqAXccPP6Jl1PsT/mevZQ4gkxCOr84feUF1dzQcwewgXAB60Z42/eAMCY6izpJvWw0LwlCiMIQnqKIz9G2kLpFYHkHg/DBn33j4CAuK5kvztM3mvAO/gAsBjnpszra8O7S0Aw6izpJMI2PCPiyEwNgZ48yWLeYSMCyQ+CiO5IuS9TnOBVyJ5/qqrq5+KU0dh3ccFgIc89/1pA3RNewvAYOosaSMA37AEgqdGIELc+8jcw27REf9HLswtXpsfIF6HTF5SNa82Rp2EdQ8XAB7x/PcvP17T9LcAVFBnSRe9p4nQWR28Vz9zNXNDALH3ciAjHhoWkPLdgC/0jYvueaKDOgo7dlwAeEDN92eMhYY3AJRSZ0kLn0RgfBSBE2O8Xz/zBJkUSHzguWGBT4yEce4lv3m6iToIOzZcALhczdwZ4yDxJoBC6izpYPRLInhGJ7R87u5n3mNu8yH+t1zYbR6ZyCKwDHbqrKp5tc3UUVjXcQHgYs/fctUoTVrvQqKYOkt3iYBEYEoE/hFxviuZp0lLIPlJCIlPwoA36tyPAkbwbB4OcB9+1LrU83MuH6bB+Dsge1Fn6S7fsASCp3VChLzTN8rYkdiNBqJv58JuNKijpMN7oc7c877+6KNR6iDs6HEB4EJ7l/q9B2AAdZbuEH6J4Omd8A3nNf0sS9lA4uOwN3oDBN6K5Pm/zksE3YMLAJdZcPP0noYh/g6J4dRZukPvlULonA5oBW5/6jHWfeY2H2Jv5HlhpcBLpfn1l/FmQe7ABYCLLJg7vcSQ4u8ARlBnOWYCe2b4j4/yDH/G9iOTAvF3c5Fa6/KTBqVchG3mtKraWl6/qzh+BLtEze2VBYYUr8PFjb+WbyF8SRsCE7nxZ+xAwi8ROqcDoa92QPhcPB9GiMvQ1/e45BdM5XlkLYq3vTJrVtj0WW8AmECd5Vj5j48j9PUO6D34pYCxw9FLLPiGJmHW+yCjrq2Ux66aPCp30ZLP36AOwg6NCwDFVVdXa4V2w3MAzqHOckwEEJgcQXBqFILvNsaOighK+I5PQEY0164SEBCTqyaPaq5d8vlH1FnYwbm2vMwWx7evvQ8Cl1DnOBYi10LOpa0IjOMtwxnrKqFLhM7qRPDMTtc+qaUUD9TOnnERdQ52cDxGo7CauTNmQeIR6hzHQq9IIXxeO0TYxWOZjCnC2mUg+lo+ZIcrK4GoptlnXnbv8x9SB2H/jgsARS2cM+N8AbwEwHX9f/6RcQROj0Bo3Pgzli4yriH2eh7ML115umCDLnDKpfct2EIdhP0vLgAUtHd//78DyKHO0iXGni5L3zDe2IcxR9hAfHEOkstC1EmOgfwcPnNq1S9r26iTsD24AFBMzeyZvQHzAwj0oc7SFSJkI3xBB/TyFHUUxjwv9UUQsb/luu9kQSnfRYH5tarq2iR1FObaqSXeVHN7ZQGE+Ve3Nf5aoYWcylZu/BnLEN+IOMIXtrtvvwAhThftxsPUMdgeXAAoQgICSd8TAEZSZ+kKvdxEzqWtvKUvYxlmDEgip7IVWq67fnsS4pqFc2Z8jzoH4yEAZdTMnv4TCPFT6hxdYQxJIHROJ4TusrcQxjzEjmiIvZIPy137BZhS4KzL71vwHnWQbMYFgAJqZk8/F0K8Chf1yATGxxCYGOE7iDEFyKRA7LV8l60QEDsswxo3/Z7n66mTZCt+fBN7Ye6M/pbEJwBKqLMcFQEEpkYQGMub+zCmFBuIvZ6H1EZXHSb0AfJTX+FJgTRc88bpRU9WfytoSbwAFzX+oTM7ufFnTEUaEDq3A74RrlqGOwntvvuoQ2QrLgAIhTuSvwUwjjrHUdGA4Fmd8I2IUydhjB2KBoTO7ID/BFcV6d+tnT39auoQ2YiHAIjUzJ7xXQg8RJ3jqGhA+Nx2GIO5l44xV5BAYnEOEktds2FQHAJTq+5b8Cl1kGzCBQCB5+dcMUmD/DsAP3WWIzIkwue3w+jPa/wZc5vEhzlIfOSaImATfKmTeKfAzOEhgAx76bZr8jTI+XBB4y98Ejnf4MafMbcKTIwgMDlCHeNoDULK91vqENmEC4AMS1qxhwAMos5xRBoQOq8Dem9u/Blzs8C4GAITo9QxjtaMhXOmX0kdIlvwEEAGLZwz/VIBsYg6x5EITSJ4fgd8A3nMnzGvSLyfg8SnrhgO6ITUTqya9+wG6iBexz0AGfLCbVf0ERCPUuc4Ig0IfrWTG3/GPCZwSgS+Ma5YxZMLYT9VU1mpUwfxOi4AMqC6ulqzUvIPAIqosxyWAEJn8HG+jHmSAEKnuWYp7xT0MX5EHcLreAggA2rmTv8BpPgFdY7D2vdwcMcbAusi25JYs6wNKz9qwZZ1ndi1PY5E3AIA5Ob7UN4vhEHH5+GEyUXoOziHOC1zlA1E38yDuU75HQNN2PK0qgeeW0IdxKu4AHBYzdwZ4yDxPhSf9R+YHEFgnKs2D2FHoXlXAn96civeerEezbuOrmdn4HF5OH96H3ytqjf8Qe4k9CQbiP65AOYW5c8O2BQwgmMvuueJDuogXsRjLA6qmV0ZgtDfANCTOsvh+EfHEZzsmlnC7Cgk4zaefXAjfnHTCqz4sAWxiHXU/9/W3Ul8/O5u/LV2OwpLAxgwPA+CXxW8RQC+QUmYW/yQUaWLvEJTmr0WLVn5EnUQL+ICwEGVp5z4MwDfpM5xOEb/JEJf7eC+IA+pW9eJO676FItf3wnLOvajmmMRC4v/ugub13Rg3Gkl8AeUbihYV+mAMTAJc4MfMqnudyuAE6smjVlS+8HKjdRZvIYf+w5ZdMv0MbYtPgGgbB+bXmQiXNkG4T/2RoKpZeWHLbjzuqWIdppp/bv9huTgv58eh9LyYFr/LqNnN+mIvFAAmVC3CACwBfHUqKrf1nZSB/ESpb9xt6qprNRtW/weCjf+Wo6N0EXt3Ph7yJqlbfjxNZ+lvfEHgK0bIrht+idoaeQVIl6jFVsIndup+utgfxkyqqlDeA0XAE7oY8wBcDJ1jEPySYS+0Q4t16ZOwtJk1/YYfnzNZ4hHj36sv6satkTxs/9YDtPkotFrjH5JhM5Q++VaSPH9RbOnqftcdSGeA5BmL8yeMUgKUQNV3/4FEL6wA0Y5b/HrFdKWuPO6pdi2yfmJnI0NcUgJjJ2s9pYWrOv0MhOwBKwGNR9dADQpMPHs0ZN//+dPP+W3lzTgHoA0swR+ByBMneNQAlMiMPrxLn9e8kZtPVZ90pqx69U+Uodtm1xzwAzrgsApERj9VX4+iBOKciO3UKfwCi4A0qh29vSrAXyVOseh+AYlERjLa/29xDQl5j+0KbPXTNlYkOFrsgwRQOhrHdAK1H3BlpB3Pv/9y4+nzuEFXACkyYKbp/eUQtxLneNQtCILoXN4uZ/XLH59J3Ztz3xR9/dXdqBpJ08I9CIRkAif1w4Yys71CGhC+63kp1m3cQGQJj4dd0HVvf59e3/QPmV/0OwYvf3HBpLrWpbEuy/TXJs5Tys1ETpT4UmBQpy+aPaMy6ljuB0XAGmwaM60EyXEt6hzHJQAQl/thFbk3OxwRsNM2Vi+pJns+p++10R2beY83/CE0meDSOBXT99yFR9c0Q1cAKSBDe0BKPpZ+sdF4RvMXbVetGFVBxIxusLui89aIblTydOCp0agVyi6YkigT8i2eEJgNyjZaLnJwtnTqwCcRp3jYIyKFIITeY9/r6KeiR+PWti9Q903RNZ9QpMIn9sBEVSz0pPAbS/cdkUf6hxuxQVAN9TMrgwJIX5JneNghF/umfTH37Bnte6mX67VokAG5iyRY6s8HyBsmVLJZ7AbcPPQLcatAAZQpziY4OmdEHnqLuVh3efkrn9HK+bAtsNMPcbgBPwjlO3tmV4zd/pU6hBuxAXAMaqZPbM3hLiNOsfB+IYn4BvO4/5ep8L4u+QaM2sETotA60FfdB6EgBQPVldXc3vWRfyBHSMpzF8CUG4GqpZvIXi6st11jDGXEj6J0Nc6IDQFKs//66SR7euupA7hNlwAHINFs6edLIAZ1Dn+Dw0IfrWTT/hjjDlCLzPhn6DmxGIJeVfN7MoQdQ434QLgGNjQ/gsK7kIVGBeFoeqSHcaYJwTGxRRdGih6S833HeoUbsIFQBfVzpk2GQLnUec4kFZswj+B9/lnjDlM27O5mFBwZ1Eh8cOXbrsmjzqHW3AB0EVSaj+jzvB/CCB0RqeqY3OMMY/R8i34xys5FFASN+M3UIdwCy4AuqBm7vSpEDiTOseB/GNj0Mt5ORZjLHMCJ8agl6n33BECtz570xX51DncgAuArpDi59QRDiTybAR4tz/GWKZpQPAsBXseJYp9PnkzdQw34ALgKNXOvuIcAF+hznGg0JlqjsUxxrxPLzHhG6veBkECmFszu1LN01kVwgXAUZJC/pQ6w4H8x8dh9OOtWBljdIITo9AKlNsgqEBqvtnUIVTHBcBRqJ1zxYUAJlHn2J8I2QhM4a5/xhgxQyJ0Bu3BVAcjJG5eMHd6CXUOlXEBcBSkxH9SZzhQ4JQoRIj3YWWM0dP7JmEMUW778TwdgucCHIZBHUB1tbOvPFUKeyJ1jv3ppSb8x6s37qaKVNJGfV0UzY0JxCIWQjk6cvN96D0wjHCud255ocBWVMJjrxAtu5Oor4siFjFhWRKhsI6y3iGUVQSh6Qp84AoLnhpB5xY/kFLncxISNzx9y1V3z7z3GfW6KBTgnaehQ6Sw51JnOFDw1Aj33RygYWsM77zUgI/eacT6Fe2wrP87MVIIoO+QXJw0tQinf6Mcx40tIEiaPoGQTh0BoRz6DN1hmhIfv9OI917dieVLmtG86+BvsaEcA6PG98Dkr5Xh1PN7ITefH50H0nJtBMbGkfhYqd14iwK2/S0Av6EOoiJ1SjUFLbp1xlDbwhoo1NwaQxIIn9dBHUMZdes68cy8jXj/jV2QdtdWQxw3tgBX3DwY40935zDhG7Xbcf9tq0gzPPXeqejVV6kH/lExTYlXn/0Six6tQ2ND13rTQmEd583og+k3DkJeD59DCV0qJdA5vwfsDqUKw834MjW0qrZWuZmK1JRp2FQkbcyBQp+R0CWCU7gnCwDMlI3f370ON56/BItf39nlxh8A1ixrw4+v/gw/nbUMbc3uW03ReyDtYZT+gIayiiBphmOxfmU7bjh/CR7+6ZouN/4AEItaePHxLbj2zH/inZcaHEjoYj6JwCnKTU4eKPsa36QOoSJlGjfVvHjjzGIpcRV1jv35T4pDy+eJf61NSdxS9TFqH6k7aFd/Vy15cxduOH8J1q1sT0O6zBkyMg8+P91PePgJBa4bF//rwu2Yc9lH2Lq++0dmt7ek8Mvvr8Svf/QFLJP34tjHNywBvadaOwQKiNupM6iIC4BDMP2pGwHQvmLtR8ux4R+nXGWdcU07E5h72UdYs6wt7X/39mkfY9n7zWn9u04KhHSMHN+D7PonnVpMdu1jUftIHR64YxVSyfQW0a8t2Ib/vnE5TC4C9hBA8LSIagPM42vnTJtMHUI1XAAcxGs3nReA0P6DOsf+AhOiWb/jX6TDxI/+36fYXudMIRSLWrjzuqWuKgLOvKic5LpCAGcQXftYLHx4M35/9zpIh35C77+xCw/eQTsfQyV6rxSMQWoNq0mpKTehmxoXAAcR8fX4FiB7UefYR+TZ8I3gZX8P/ecXqFvb/a7bw0nELPzk2s+wdHGTo9dJl9O/UY6iskDGrzvp7D... (35638 total length)"
			// value:
		},
		toggleShow() {
			this.show = !this.show;
		},
		// /**
		//  * crop success
		//  *
		//  * [param] imgDataUrl
		//  * [param] field
		//  */
		cropSuccess(imgDataUrl, field) {
			console.info('%c [  field  ] ', 'color:#bada55', typeof field, field );
			console.info('-------- crop success --------');
			this.imgDataUrl = imgDataUrl;

			this.logoMod.url = imgDataUrl;
			this.logoMod.value = imgDataUrl;

			const logo = this.logoMod;
			this.$emit('updateFile', logo);

		},
		// /**
		//  * upload success
		//  *
		//  * [param] jsonData  server api return data, already json encode
		//  * [param] field
		//  */
		cropUploadSuccess(jsonData, field) {
			console.log('-------- upload success --------');
			console.log(jsonData);
			console.log('field: ' + field);
		},
		// /**
		//  * upload fail
		//  *
		//  * [param] status    server api return error status, like 500
		//  * [param] field
		//  */
		cropUploadFail(status, field) {
			console.log('-------- upload fail --------');
			console.log(status);
			console.log('field: ' + field);
		},
	},
};
</script>

<style scoped lang="scss">
@import "LogoBlock";
</style>
<style lang="scss">
@import "LogoBlockAll";
</style>
